import { supabase } from '../../shared/supabase/supabaseClient';

/** Combos phantom con vendible ≤ umbral (default 5). */
export async function fetchComboLowSellableCount(
  branchId: string,
  threshold = 5,
): Promise<number | null> {
  if (!branchId.trim()) return null;
  const { data, error } = await supabase.rpc('catalog_count_combo_low_sellable', {
    p_branch_id: branchId,
    p_threshold: threshold,
  });
  if (error) {
    console.warn('[home] catalog_count_combo_low_sellable', error.message);
    return null;
  }
  return typeof data === 'number' ? data : Number(data ?? 0);
}
